import Iconfont from "@repo/ui/iconfont"
import Link from "next/link"
import React from "react"
import { Dropdown } from "antd"

import ClientOnly from "../../../ClientOnly"
import { NavigationItem } from "./type"

export const SimpleNavItem = ({ item, children }: { item: NavigationItem; children: React.ReactNode }) => {
  // 如果有子菜单，使用 antd Dropdown
  if (item.children && item.children.length > 0) {
    const menuItems = item.children.map((child, index) => ({
      key: child.href || `item-${index}`,
      label: (
        <Link
          href={child.href || "#"}
          className="simpleDropdownItem"
          prefetch={false}
          {...(child.openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {child.title}
        </Link>
      ),
      children: !child.pcHide
        ? child.children?.map((grandchild, grandchildIndex) => ({
            key: grandchild.href || `grandchild-${grandchildIndex}`,
            label: (
              <Link
                href={grandchild.href || "#"}
                className="simpleDropdownItem"
                {...(grandchild.openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              >
                {grandchild.title}
              </Link>
            ),
          }))
        : undefined,
    }))

    return (
      <ClientOnly
        fallback={
          <div className="navItem">
            <span className="navItemText">{children}</span>
            <Iconfont
              type="icon-xialacu"
              className="navItemIcon"
              style={{
                fontSize: 20,
              }}
            />
          </div>
        }
      >
        <Dropdown
          menu={{ items: menuItems }}
          trigger={["hover"]}
          placement="bottomLeft"
          overlayClassName="simpleNavDropdown simpleNavDropdownGlobal"
          getPopupContainer={(triggerNode) =>
            triggerNode?.closest?.(".headerWrapper") ?? document.querySelector(".headerWrapper") ?? document.body
          }
        >
          <div className="navItem">
            <span className="navItemText">{children}</span>
            <Iconfont
              type="icon-xialacu"
              className="navItemIcon"
              style={{
                fontSize: 20,
              }}
            />
          </div>
        </Dropdown>
      </ClientOnly>
    )
  }

  // 没有子菜单，直接链接
  return (
    <Link
      href={item.href || "#"}
      className="navItem"
      prefetch={false}
      {...(item.openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    >
      <span className="navItemText">{children}</span>
    </Link>
  )
}
